import { OepaUserAccount } from "@ohioepa/oepa-common-lib";

export const extLiveReloadAccount: OepaUserAccount = {
    loginName: 'Stars2Test',
    accountID: 'Stars2Test',
    firstName: 'Stars2',
    lastName: 'Test Account',
    corePersonID: {
      value: 2994
    },
    primaryEMailAddress: 'arunee.niamlarb@epa.ohio.gov',
    type: 'APPLICATION_PORTAL',
    roleList: [
      {
        name: 'StarsRoles',
        description: 'Stars User Role',
        privilegeList: [
          { type: 'RETRIEVE_REVENUE', name: 'Retrieve Revenue'}
        ]
      }
    ]
  }